import { useEffect } from 'react'

import {
  Outlet,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom'

import { documentApi } from '../../api/documentsApi'
import DocumentDetailsLayout from '../../components/DocumentDetailsLayout/DocumentDetailsLayout'
import DocumentInformation from '../../components/DocumentInformation/DocumentInformation'
import { DocDetailQuery } from '../../enums'

/**
 * TODO: implement download of un-viewable filetypes
 */
const DocumentPage = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { documentId } = useParams()
  const [searchParams, setSearchParams] = useSearchParams()
  const httpGetDocument = documentApi.useGetDocumentByIdQuery(
    documentId ?? '',
    {
      skip: !documentId,
    }
  )

  useEffect(() => {
    const practiceId = httpGetDocument.data?.data.practice_id
    const paramPracticeId = searchParams.get(DocDetailQuery.PRACTICE_ID)

    if (practiceId && practiceId !== paramPracticeId) {
      const newSearchParams = new URLSearchParams(location.search)
      newSearchParams.set(DocDetailQuery.PRACTICE_ID, practiceId)

      navigate(
        {
          pathname: location.pathname,
          search: `?${newSearchParams.toString()}`,
          hash: location.hash,
        },
        {
          replace: true,
        }
      )
    }
  }, [
    httpGetDocument.data?.data.practice_id,
    location.hash,
    location.pathname,
    location.search,
    navigate,
    searchParams,
    setSearchParams,
  ])

  return (
    <DocumentDetailsLayout>
      <DocumentInformation />
      <Outlet />
    </DocumentDetailsLayout>
  )
}

export default DocumentPage
